export const REPORT_REASON_KEYS = [
  "SPAM",
  "INAPPROPRIATE_CONTENT",
  "HARASSMENT",
  "HATE_SPEECH",
  "OTHER",
] as const;

export type ReportReasonKey = (typeof REPORT_REASON_KEYS)[number];
